exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".separator{border-bottom:1px solid #ddd;margin-bottom:20px}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Fields/NewField.vue"],"names":[],"mappings":"AACA,WACE,6BAAiC,AACjC,kBAAoB,CACrB","file":"NewField.vue","sourcesContent":["\n.separator {\n  border-bottom: 1px #dddddd solid;\n  margin-bottom: 20px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24e1589e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Fields/NewField.vue
// module id = 1015
// module chunks = 9